import { default as discounts } from "./discounts.json";
import { default as pharmacies } from "./pharmacies.json";

const data: { [key: string]: any } = {
  discounts: discounts,
  pharmacies: pharmacies,
};

const scripthero = {
  getDiscounts: () => data["discounts"],
  getPharmacies: () => data["pharmacies"],
};

export default scripthero;
